import { Box, InputBase, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import SearchIcon from "../../assets/SVG/searchIcon";

export default function SearchInput({ value, mb,mr,...props }) {
  const [focus, setFocus] = useState();
  useEffect(() => {
    if (value) {
      setFocus(true);
    }
  }, [value]);
  return (
    <>
      <Box
        mb={mb||"20px"}
        mr={mr||""}
        display="flex"
        alignItems="center"
        borderRadius={"10px"}
        width={focus ? "200px" : "100px"}
        height="40px"
        onClick={() => value?setFocus(true): setFocus(!focus)}
        px="5px"
        gap="10px"
        // border='solid 1px #579bfc'
        sx={
          focus
            ? {
                transition: "0.3s all",
                border: "solid 1px #127A92",
                "& svg": {
                  "& path": {
                    fill: "#127A92",
                  },
                },
              }
            : {
                transition: "0.3s all",
                ":visited": {
                  bgcolor: "white",
                },
                ":hover": {
                  bgcolor: "#88929B",
                  "& svg": {
                    "& path": {
                      fill: "white",
                    },
                  },
                  "& input": {
                    "::placeholder": {
                      opacity: "1",
                      color: "white",
                    },
                  },
                },
              }
        }
      >
        <SearchIcon />
        {/* <Typography color="#787878">جستجو</Typography> */}
        <InputBase
          value={value}
          placeholder="جستجو"
          {...props}
          sx={{ width: "50%" }}
        />
      </Box>
    </>
  );
}
